import { render, staticRenderFns } from "./GreaterHeights.vue?vue&type=template&id=996097ce&scoped=true&"
import script from "./GreaterHeights.vue?vue&type=script&lang=js&"
export * from "./GreaterHeights.vue?vue&type=script&lang=js&"
import style0 from "./GreaterHeights.vue?vue&type=style&index=0&id=996097ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996097ce",
  null
  
)

export default component.exports